import { Tracking } from '@panamax/app-state';
import { MyOrdersTracingMessages } from '../my-orders-tracing.constants';

/**
 * NOTE json parse/strigify won't work on functions therefore no transformFunc
 * */
export const viewExceptionLinkClickTrace: Tracking = {
  tracing: {
    data: {
      traceContext: MyOrdersTracingMessages.traceContext,
      isEndOfTrace: true,
      isStartOfTrace: true,
      attributes: {
        order: {
          orderId: undefined,
          requestedDeliveryDate: undefined,
          confirmedDeliveryDate: undefined,
          tandemOrderNumber: undefined,
          totalAmount: undefined,
          origOrderId: undefined,
          origSplitOrderId: undefined,
          customerNumber: undefined,
          divisionNumber: undefined,
          departmentNumber: undefined,
        },
      },
    },
  },
};
